import * as React from "react";
import AppModal from "../../common/components/AppModal";

type Props = {
    open: boolean;
    isLoading: boolean;
    onCancel: () => void;
    onConfirm: () => void;
};

const SeparateSubtaskStatusesModal: React.FC<Props> = ({
    open,
    isLoading,
    onCancel,
    onConfirm,
}) => {
    return (
        <AppModal
            centered
            width={680}
            open={open}
            onCancel={onCancel}
            className="alpha-modal"
            cancelButtonTitle="Cancel"
            onCancelClick={onCancel}
            cancelButtonProps={{
                disabled: isLoading,
            }}
            submitButtonTitle="Use separate statuses"
            onSubmitClick={onConfirm}
            submitButtonProps={{
                loading: isLoading,
            }}
        >
            <div
                style={{
                    color: "#13254C",
                    fontSize: 18,
                    fontWeight: 700,
                    marginBottom: 16,
                }}
            >
                Use separate subtask statuses?
            </div>
            <div
                style={{
                    color: "#5B6B8C",
                    fontSize: 14,
                    lineHeight: 1.7,
                }}
            >
                Separate statuses will be created for subtasks. Subtasks will no
                longer use the main task statuses.
            </div>
        </AppModal>
    );
};

export default SeparateSubtaskStatusesModal;
